export class NativeStreamTransformConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "onCastOverflow",
            "baseName": "onCastOverflow",
            "type": "NativeStreamCastOverflowAction",
            "format": ""
        },
        {
            "name": "includeColumns",
            "baseName": "includeColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "dropColumns",
            "baseName": "dropColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<NativeStreamTransformColumn>",
            "format": ""
        },
        {
            "name": "inputFilter",
            "baseName": "inputFilter",
            "type": "string",
            "format": ""
        },
        {
            "name": "udfs",
            "baseName": "udfs",
            "type": "Array<NativeStreamTransformUdf>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamTransformConfig.attributeTypeMap;
    }
    constructor() {
    }
}
